module.exports = __webpack_public_path__ + "media/images/emblems/Buehl_bei_Aarberg-coat_of_arms-5480b77b7769bddb138a6dcbdf586874.svg";